
















import Vue from "vue";
export default Vue.extend({
  name: "Link",
  props: {
    variant: {
      type: String,
      required: false
    },
    inverted: {
      type: Boolean,
      required: false
    },
    small: {
      type: Boolean,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    text: {
      type: String,
      required: false
    },
    clickFunction: {
      type: Function,
      required: true
    }
  }
});
